import script from "./DashboardStatPills.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardStatPills.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardStatPills.vue?vue&type=style&index=0&id=ea17dd74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea17dd74"]])

export default __exports__